import { defineStore } from 'pinia'
import { watch } from 'vue';
import { RouteLocationNormalized } from 'vue-router'

type reloginCallback = () => void

type forceReloginArgs = {
  successCallback?: () => void,
  failureCallback?: () => void
}

export const useRouterStore = defineStore('router', {
  state: () => ({
    reloginRequired: false,
    reloginSuccessCallback: undefined as reloginCallback | undefined,
    reloginFailureCallback: undefined as reloginCallback | undefined,
    loginSuccess: false,
    loginDismissed: false,
    lastNonPremiumPageVisited: null as RouteLocationNormalized | null,
  }),
  actions: {
    forceRelogin(args?:forceReloginArgs) {
      this.reloginRequired = true
      this.reloginSuccessCallback = args?.successCallback
      this.reloginFailureCallback = args?.failureCallback
    },
    async forceReloginAndWait(): Promise<object> {
      this.reloginRequired = true
      return new Promise<object>((resolve, reject) => {
        const stopLoginSuccess = watch(() => this.loginSuccess, (newVal) => {
          if (newVal) {
            this.reloginRequired = false; // Hide modal
            stopLoginSuccess(); // Stop watching
            stopLoginDismissed(); // Cleanup dismissed watcher
            resolve({message: 'success'}); // Resolve the promise
          }
        });

        const stopLoginDismissed = watch(() => this.loginDismissed, (newVal) => {
          if (newVal) {
            this.reloginRequired = false; // Hide modal
            stopLoginSuccess(); // Cleanup success watcher
            stopLoginDismissed(); // Stop watching
            reject({message: 'Login error or login dismissed'});
          }
        });
      });
    },
    async handleReloginAttempt(wasSuccess: boolean) {
      this.reloginRequired = false
      const callback = wasSuccess ? this.reloginSuccessCallback : this.reloginFailureCallback
      if (callback) {
        return callback()
      }
    },
    markLastNonPremiumPage(route: RouteLocationNormalized) {
      this.lastNonPremiumPageVisited = route
    },
  }
})